import { gsap } from "gsap";

const PromoInfoBox = () => {
	const block = document.querySelectorAll(".promo-info-box");
	if (!block) {
		return;
	}
	let mm = gsap.matchMedia();

	block.forEach((el) => {
		mm.add("(min-width: 1024px)", () => {
			el.querySelectorAll(".promo-info-box__list-item").forEach((item) => {
				const image = item.querySelector(".promo-info-box__list-image");
				const bounds = image.getBoundingClientRect();

				item.addEventListener("mousemove", (e) => {
					const xMovement = Math.min(Math.max(parseInt(e.movementX), -20), 20);

					gsap.to(image, {
						autoAlpha: 1,
						x: e.clientX - bounds.left,
						y: e.movementY - e.target.offsetHeight / 1.5,
						transformOrigin: "center",
						rotation: xMovement,
						scale: 1
					});
				});

				item.addEventListener("mouseleave", (e) => {
					gsap.to(image, {
						autoAlpha: 0,
						scale: 0
					});
				});
			});
		});

		mm.add("(max-width: 767px)", () => {
			const list = el.querySelector(".promo-info-box__list");
			gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: "top 50%",
					end: `+=${el.offsetHeight}px`,
					scrub: true,
					onEnter: () => {
						list.classList.add("active");
					},
					onEnterBack: () => {
						list.classList.add("active");
					},
					onLeave: () => {
						list.classList.remove("active");
					},
					onLeaveBack: () => {
						list.classList.remove("active");
					}
				}
			});

			el.querySelectorAll(".promo-info-box__list-item").forEach((item) => {
				gsap.timeline({
					scrollTrigger: {
						trigger: item,
						start: "top 50%",
						end: `+=${item.offsetHeight}px`,
						scrub: true,
						onEnter: () => {
							item.classList.add("active");
						},
						onEnterBack: () => {
							item.classList.add("active");
						},
						onLeave: () => {
							item.classList.remove("active");
						},
						onLeaveBack: () => {
							item.classList.remove("active");
						}
					}
				});
			});
		});
	});
};

export default PromoInfoBox;
